import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-volume-off-sharp",
  "use": "icon-volume-off-sharp-usage",
  "viewBox": "0 0 512 512",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" class=\"ionicon\" viewBox=\"0 0 512 512\" id=\"icon-volume-off-sharp\"><title>Volume Off</title><path d=\"M237.65 176.1H144v159.8h93.65L368 440V72L237.65 176.1z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol